import produce from "immer";
import { constants } from "./actions";
import { commonConstants } from "../common/actions";
import clearPersistedLocalStorage from "../../utils/persistedLocalStorage";
import moment from "moment-timezone";

const { REQUEST, SUCCESS, FAILURE } = commonConstants;
const {
  UPDATE_RETURN_CALL_FORM_FIELD,
  GET_RETURN_CALLS,
  RETRIEVE_RETURN_CALL,
  RESOLVE_RETURN_CALL,
  DELETE_RETURN_CALL,
} = constants;

const initState = {
  returnCallList: [],
  callTakers: [],
  loading: {},
  success: {},
  error: {},
  returnCall: false,
  returnCallDate: null,
  returnCallDetails: "",
  safeReturnCallDetails: "",
  returnCallFollowUpNotes: "",
  originCallReportId: 0,
  callType: "RETURN",
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case UPDATE_RETURN_CALL_FORM_FIELD:
      if (action.field === "returnCall" && action.value) {
        return produce(state, (draft) => {
          draft[action.field] = action.value;
          draft.loading = {};
          draft.error = {};
          draft.success = {};
          draft.returnCallDate = new Date();
        });
      }
      return produce(state, (draft) => {
        draft[action.field] = action.value;
        draft.loading = {};
        draft.error = {};
        draft.success = {};
      });

    case GET_RETURN_CALLS + REQUEST:
      return produce(state, (draft) => {
        draft.loading = { source: GET_RETURN_CALLS };
        draft.success = {};
        draft.error = {};
      });
    case GET_RETURN_CALLS + SUCCESS:
      return produce(state, (draft) => {
        draft.returnCallList = action.payload.callReports.filter(
          (call) => !!call.originCallReportId
        );
        draft.callTakers = action.payload.callTakers;
        draft.loading = {};
        draft.success = action.payload;
        draft.error = {};
      });
    case GET_RETURN_CALLS + FAILURE:
      return produce(state, (draft) => {
        draft.loading = {};
        draft.success = {};
        draft.error = action.payload;
      });

    case RETRIEVE_RETURN_CALL + REQUEST:
      return produce(state, (draft) => {
        draft.loading = { source: action.payload.source };
        draft.success = {};
        draft.error = {};
      });
    case RETRIEVE_RETURN_CALL + SUCCESS:
      const page = action.payload.page;
      const newResult = {
        ...page,
      };
      clearPersistedLocalStorage();
      return {
        ...newResult,
        success: {
          source: action.payload.source,
          message: action.payload.message,
        },
        loading: {},
        error: {},
      };
    case RETRIEVE_RETURN_CALL + FAILURE:
      return produce(state, (draft) => {
        draft.loading = {};
        draft.error = {
          source: action.payload.source,
          message: action.payload.message,
        };
      });

    case RESOLVE_RETURN_CALL + REQUEST:
      return produce(state, (draft) => {
        draft.loading = { source: RESOLVE_RETURN_CALL };
        draft.success = {};
        draft.error = {};
      });
    case RESOLVE_RETURN_CALL + SUCCESS:
      clearPersistedLocalStorage();
      return {
        ...initState,
        success: {
          source: action.payload.source,
          message: action.payload.message,
        },
      };
    case RESOLVE_RETURN_CALL + FAILURE:
      return produce(state, (draft) => {
        draft.loading = {};
        draft.success = {};
        draft.error = action.payload;
      });

    case DELETE_RETURN_CALL + REQUEST:
      return produce(state, (draft) => {
        draft.success = {};
        draft.loading = { source: DELETE_RETURN_CALL };
        draft.error = {};
      });
    case DELETE_RETURN_CALL + SUCCESS:
      return produce(state, (draft) => {
        draft.success = {
          source: action.payload.source,
          message: action.payload.message,
        };
        draft.loading = {};
        draft.error = {};
      });
    case DELETE_RETURN_CALL + FAILURE:
      return produce(state, (draft) => {
        draft.success = {};
        draft.error = {
          source: action.payload.source,
          message: action.payload.message,
        };
        draft.loading = {};
      });

    default:
      return produce(state, (draft) => {
        draft.returnCallList = [];
        draft.loading = {};
        draft.success = {};
        draft.error = {};
      });
  }
}
